import PropTypes from 'prop-types';

import { Button } from '#/modules/commonComponents/button';
import SideMsg from '#/modules/commonComponents/SideMsg';
import {
  signReceiptSideMsgDetailBlock,
  signReceiptSideMsgStatusBlock,
} from '#/modules/crmMgmt/aftersales/signReceipt/data/signReceiptSideMsgConfig';
import { canDownloadSignReceiptExcel } from '#/modules/crmMgmt/aftersales/signReceipt/helper/signReceiptStatus';
import useSignReceiptExcelDownload from '#/modules/crmMgmt/aftersales/signReceipt/hooks/useSignReceiptExcelDownload';

const SignReceiptSideMsg = ({ displayData }) => {
  const excelDownload = useSignReceiptExcelDownload(displayData?.id);
  const canPrint = canDownloadSignReceiptExcel(displayData?.status)
    && excelDownload.canPrint;

  const blocks = [
    signReceiptSideMsgStatusBlock,
    {
      condition: () => canPrint,
      fields: [
        {
          key: 'actions',
          label: '操作',
          render: () => (
            <div className="side_msg-row">
              <h3>操作</h3>
              <div className="flex flex-wrap items-center gap-2">
                <Button
                  type="button"
                  variant="outline"
                  disabled={excelDownload.isPrintPending}
                  onClick={excelDownload.handlePrint}
                >
                  {excelDownload.isPrintPending ? '下載中…' : '列印本筆'}
                </Button>
              </div>
            </div>
          ),
        },
      ],
    },
    signReceiptSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="簽收單"
      titleValue="signReceiptNo"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

SignReceiptSideMsg.propTypes = {
  displayData: PropTypes.object,
};

export default SignReceiptSideMsg;
